import request from '@/utils/request';

const baseURL = '/financeapi/finance/authority/employee/'

export const employeeList = data =>
  request({
    data,
    url: `${baseURL}list`,
    method: 'post'
  });

export const employeeEdit = data =>
  request({
    data,
    url: `${baseURL}edit`,
    method: 'post'
  });

export const employeeFind = data =>
  request({
    data,
    url: `${baseURL}find`,
    method: 'post'
  });